import { environment } from '../../../environments/environment';

const BASE = environment.apiBaseUrl;

export const API_ENDPOINTS = {
  // ── Auth ──
  AUTH: {
    LOGIN: `${BASE}/api/Auth/login`,
  },

  // ── Vendor Recon ──
  VENDOR_RECON: {
    FREQUENCIES: `${BASE}/api/VendorRecon/frequencies`,
    DIVISIONS: `${BASE}/api/VendorRecon/divisions`,
    ENTITY_NAMES: `${BASE}/api/VendorRecon/entity-names`,
    VENDOR_NAMES: `${BASE}/api/VendorRecon/vendor-names`,
    CLASSIFICATIONS: `${BASE}/api/VendorRecon/classifications`,
    PERIODS: `${BASE}/api/VendorRecon/periods`,
  },

  // ── Dashboard ──
  DASHBOARD: {
    USER_DASHBOARD: `${BASE}/api/VendorRecon/user-dashboard`,
    RECON_METRICS: `${BASE}/api/VendorRecon/recon-metrics`,
    VENDOR_LEVEL_SUMMARY: `${BASE}/api/VendorRecon/vendor-level-summary`,
  },

  // ── DQ Dashboard ──
  DQ_DASHBOARD: {
    INGESTION_CUE_CARD: `${BASE}/api/DataQuality/ingestion-cue-card`,
    DQ_CHECK_CUE_CARD: `${BASE}/api/DataQuality/dq-check-cue-card`,
    RULE_EXEC_CUE_CARD: `${BASE}/api/DataQuality/rule-exec-cue-card`,
    RULE_EXEC_GRID: `${BASE}/api/DataQuality/rule-exec-grid`,
    TOP_5_RULES_BY_EXEC_TIME: `${BASE}/api/DataQuality/top-5-rules-by-exec-time`,
    RULE_EXEC_TIME_TREND: `${BASE}/api/DataQuality/rule-exec-time-trend`,
    TOP_5_FAILED_RULES: `${BASE}/api/DataQuality/top-5-failed-rules`,
    RULE_FAILURE_DETAILS: `${BASE}/api/DataQuality/rule-failure-details`,
    DQ_QUICK_INSIGHTS: `${BASE}/api/DataQuality/dq-quick-insights`,
    DQ_TOP_3_FREQUENT_ISSUES: `${BASE}/api/DataQuality/dq-top-3-frequent-issues`,
    DQ_DETAILS: `${BASE}/api/DataQuality/dq-details`,
    DQ_FAILED_CHECKS_TREND: `${BASE}/api/DataQuality/dq-failed-checks-trend`,
    INGESTION_FILE_TREND: `${BASE}/api/DataQuality/dq-file-trend`,
    INGESTION_GRID: `${BASE}/api/DataQuality/ingestion-grid`,
    DQ_GRID: `${BASE}/api/DataQuality/dq-grid`,
  },

  // ── Reconciled Transactions ──
  RECON: {
    CUECARD: `${BASE}/api/Recon/recon-cuecard`,
    MATCHED_TRANSACTIONS: `${BASE}/api/recon/matched-transactions`,
    REOPEN: `${BASE}/api/Recon/reopen`,
  },

  // ── Unreconciled Transactions ──
  UNRECON: {
    CUECARD: `${BASE}/api/Unrecon/cuecard`,
    OPEN_TRANSACTIONS_VEN: `${BASE}/api/Unrecon/open-transactions-ven`,
    OPEN_TRANSACTIONS_FKP: `${BASE}/api/Unrecon/open-transactions-fkp`,
    OPEN_TRANSACTIONS: `${BASE}/api/unrecon/open-transactions`,
    VENDOR_SUGGESTED: `${BASE}/api/Unrecon/vendor-suggested`,
    SUBSEQUENTLY_ACCOUNTED: `${BASE}/api/Unrecon/subsequently-accounted`,
    PARTIALLY_MATCHED: `${BASE}/api/Unrecon/partially-matched`,
    ML_SUGGESTED: `${BASE}/api/Unrecon/ml-suggested`,
    WORKFLOW_AUDIT_LOG: `${BASE}/api/Unrecon/workflow-audit-log`,
    AUDIT_TRAIL: `${BASE}/api/Unrecon/audit-trail`,
    GET_FILE_URL: `${BASE}/api/Unrecon/GetFile-url`,
  },

  // ── Vendor Upload ──
  VENDOR_UPLOAD: {
    BALANCE: `${BASE}/api/vendor-upload/balance`,
    LEDGERS: `${BASE}/api/vendor-upload/ledgers`,
    UPLOAD: `${BASE}/api/vendor-upload/upload`,
    PREV_BALANCE: `${BASE}/api/VendorUpload/prev-balance`,
    UPLOAD_VIEW: `${BASE}/api/VendorUpload/upload-view`,
    LEDGER_UPLOAD: `${BASE}/api/VendorUpload/vendor-ledger-upload`,
    WORKFLOW: `${BASE}/api/VendorUpload/vendor-upload-workflow`,
    PRESIGNED_URL: `${BASE}/api/VendorUpload/presigned-url`,
    HITL_HEADER: `${BASE}/api/VendorUpload/hitl-header`,
    HITL_SUBMIT: `${BASE}/api/VendorUpload/hitl-submit`,
    EXPORT_SIGNOFF: `${BASE}/api/VendorUpload/export-signoff`,
    AUDIT_TRAIL: `${BASE}/api/VendorUpload/vendor-upload-audit-trail`,
  },

  // ── Recon Statement ──
  RECON_STATEMENT: {
    GET_RECON_STATEMENT: `${BASE}/api/ReconStatement/get-recon-statement`,
    EXPORT_RECON_STATEMENT: `${BASE}/api/ReconStatement/export-recon-statement`,
    UPDATE_RECON_STATEMENT: `${BASE}/api/ReconStatement/update-recon-statement`,
    SIGN_OFF: `${BASE}/api/ReconStatement/sign-off-recon-statement`,
  },

  // ── Human in Loop ──
  HIL: {
    FILES: `${BASE}/api/hil/files`,
  },

  // ── DN / CN Mapping ──
  DN_CN: {
    ENTITIES: `${BASE}/api/DnCn/entities`,
    VENDOR_NAMES: `${BASE}/api/DnCn/vendor-names`,
    VENDOR_CODES: `${BASE}/api/Dncn/Get-vendorcode`,
    DIVISIONS: `${BASE}/api/DnCn/divisions`,
    BUS: `${BASE}/api/Dncn/bu`,
    PAN_NUMBERS: `${BASE}/api/Dncn/Get-pannumber`,
    DN_TYPES: `${BASE}/api/Dncn/dn-type`,
    SUB_DN_TYPES: `${BASE}/api/Dncn/sub-dn-type`,
    CUE_CARD: `${BASE}/api/Dncn/cue-card`,
    DN_VIEW: `${BASE}/api/Dncn/dn-view`,
    VENDOR_VIEW: `${BASE}/api/Dncn/vendor-view`,
    SUMMARY: `${BASE}/api/DnCn/summary`,
    OPEN_DISPUTED: `${BASE}/api/DnCn/open-disputed`,
    MAPPED_DNS: `${BASE}/api/DnCn/mapped-dns`,
    EXPORT_SUMMARY: `${BASE}/api/DnCn/export-summary`,
    EXPORT_OPEN_DISPUTED: `${BASE}/api/DnCn/export-open-disputed`,
    EXPORT_MAPPED_DNS: `${BASE}/api/DnCn/export-mapped-dns`,
    MAP_DN: `${BASE}/api/DnCn/map-dn`,
    DNCN_USER_ACTIONS: `${BASE}/api/Dncn/dncn-user-actions`,
    RESOLVE_DN: `${BASE}/api/DnCn/resolve-dn`,
    BULK_UPLOAD: `${BASE}/api/Dncn/dncn-bulk-upload`,
    OPEN_DN_CUE_CARD: `${BASE}/api/Dncn/open-dn-cue-card`,
    OPEN_DN_GRID: `${BASE}/api/Dncn/open-dn-grid`,
    L2_GRID: `${BASE}/api/Dncn/Get-L2-grid`,
    DISPUTED_DN_GRID: `${BASE}/api/Dncn/disputed-dn-grid`,
    MAPPED_DN_GRID: `${BASE}/api/Dncn/mapped-dn-grid`,
    BULK_UPLOAD_GRID: `${BASE}/api/Dncn/bulk-upload-grid`,
    DISPUTE_REASONS: `${BASE}/api/Dncn/dn-dispute-reasons`,
    AUDIT_TRAIL: `${BASE}/api/Dncn/audit-trail`,
    BULK_AUDIT_TRAIL: `${BASE}/api/Dncn/bulk-audit-trail`,
  },

  // ── Open Items Management ──
  OPEN_ITEMS: {
    DIVISIONS: `${BASE}/api/OpenItems/divisions`,
    ENTITIES: `${BASE}/api/OpenItems/entities`,
    VENDOR_GROUPS: `${BASE}/api/OpenItems/vendor-groups`,
    CLASSIFICATIONS: `${BASE}/api/OpenItems/classifications`,
    PERIODS: `${BASE}/api/OpenItems/periods`,
    CUE_CARD: `${BASE}/api/OpenItems/cue-card`,
    BUYER: `${BASE}/api/OpenItems/buyer`,
    VENDOR: `${BASE}/api/OpenItems/vendor`,
    PARTIAL: `${BASE}/api/OpenItems/partial`,
    SUMMARY: `${BASE}/api/OpenItems/summary`,
    TRANSACTIONS: `${BASE}/api/OpenItems/transactions`,
    ASSIGN: `${BASE}/api/OpenItems/assign`,
    WORKFLOW: `${BASE}/api/OpenItems/workflow`,
    AUDIT_TRAIL: `${BASE}/api/OpenItems/audit-trail`,
    OPEN_REASON: `${BASE}/api/OpenItems/open-reason`,
    VENDOR_EXPORT: `${BASE}/api/OpenItems/vendor/export`,
    BUYER_EXPORT: `${BASE}/api/OpenItems/buyer/export`,
    PARTIAL_EXPORT: `${BASE}/api/OpenItems/partial/export`,
  },

  // ── ML Model ──
  ML_MODEL: {
    SUGGESTED_RULES: `${BASE}/api/MLModel/ML-Suggested-Rules`,
    AUDIT_LOG: `${BASE}/api/MLModel/audit-log-ml-rule`,
    UPDATE_RULE: `${BASE}/api/MLModel/update-ml-rule`,
  },

  // ── Rule Management ──
  RULE_MANAGEMENT: {
    EMBEDDED_RULES: `${BASE}/api/RuleManagement/Get-rules`,
    RULE_STATUS: `${BASE}/api/RuleManagement/rules/status`,
    RULE_MODIFY: `${BASE}/api/RuleManagement/rules/modify`,
    VENDOR_GROUP_NAMES: `${BASE}/api/RuleManagement/vendor-group-names`,
    CREATE_RULE_META: `${BASE}/api/RuleManagement/create-rule/meta`,
    CREATE_RULE_VALIDATE: `${BASE}/api/RuleManagement/create-rule/validate`,
    CREATE_RULE_SUBMIT: `${BASE}/api/RuleManagement/create-rule/submit`,
    CREATE_RULE_DETAILS: `${BASE}/api/RuleManagement/create-rule/details`,
  },

  // ── Threshold Management ──
  THRESHOLD_MANAGEMENT: {
    GET: `${BASE}/api/Admin/get-thresholds`,
    SAVE: `${BASE}/api/Admin/edit-thresholds`,
  },

  // ── Master Upload ──
  MASTER_UPLOAD: {
    GET_MASTER_OPTIONS: `${BASE}/api/Admin/master-dropdown`,
    MASTER_FILE: `${BASE}/api/Admin/master-file`,
    INGEST_FILE: `${BASE}/api/Admin/upload-master-file`,
  },

  // ── Job Status ──
  JOB_STATUS: {
    JOB_STATUS_DROPDOWN: `${BASE}/api/Admin/job-status-dropdown`,
    JOB_STATUS_GRID: `${BASE}/api/Admin/job-status`,
  },

  // ── User Management ──
  USER_MANAGEMENT: {
    USER_LIST: `${BASE}/api/Admin/Getuser`,
    UPDATE_USER_STATUS: `${BASE}/api/Admin/user-management/status`,
    ROLE_OPTIONS: `${BASE}/api/Admin/Getroles`,
    DIVISION_OPTIONS: `${BASE}/api/Admin/divisions`,
    ENTITY_OPTIONS: `${BASE}/api/Admin/entity-names-new`,
    VENDOR_OPTIONS: `${BASE}/api/Admin/vendor-names-new`,
    CREATE_USER: `${BASE}/api/Admin/Createuser`,
    GET_USER_BY_ID: `${BASE}/api/Admin/Getuser-account`,
    UPDATE_USER: `${BASE}/api/Admin/Modifyuser`,
  },
};
